import { render, staticRenderFns } from "./AttributeDeleteDialog.vue?vue&type=template&id=57026c5f"
import script from "./AttributeDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AttributeDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports